<app-header [forceLightBackground]="true"></app-header>
<div class="admin-access-requests">
  <div class="admin-access-requests--layout">
    <app-admin-sidebar class="admin-access-requests--sidebar"></app-admin-sidebar>
    <div class="admin-access-requests--content">
      <app-page-header></app-page-header>
      <div class="access-requests-container">
        <ng-template #accessRequestsViewToggle>
          @if (workspace.canViewPlatformSuperset()) {
          <div class="view-toggle">
            <button
              type="button"
              class="view-toggle-btn"
              [class.active]="!showAnalytics"
              (click)="toggleAnalyticsView(false)"
              aria-label="Table View"
              title="Table View"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2"></rect>
                <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"></line>
                <line x1="9" y1="10" x2="9" y2="20" stroke="currentColor" stroke-width="2"></line>
                <line x1="15" y1="10" x2="15" y2="20" stroke="currentColor" stroke-width="2"></line>
              </svg>
            </button>
            <button
              type="button"
              class="view-toggle-btn"
              [class.active]="showAnalytics"
              (click)="toggleAnalyticsView(true)"
              aria-label="Superset View"
              title="Superset View"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M4 19L10 13L14 17L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M20 11V7H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
          </div>
          }
        </ng-template>

        <div class="analytics-panel" *ngIf="showAnalytics">
          <div class="request-status-toolbar request-status-toolbar--toggle-only">
            <div class="request-status-toolbar__actions">
              <ng-container *ngTemplateOutlet="accessRequestsViewToggle"></ng-container>
            </div>
          </div>
          <div class="analytics-panel--body">
            <div class="analytics-panel--loading" *ngIf="analyticsLoading">
              <div class="analytics-panel--spinner"></div>
              <span>Loading dashboard...</span>
            </div>

            <div class="analytics-panel--error" *ngIf="analyticsError && !analyticsLoading">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="16" r="1" fill="currentColor"/>
              </svg>
              {{ analyticsError }}
            </div>

            <div
              #analyticsMount
              class="analytics-panel--mount"
              [class.hidden]="analyticsLoading || !!analyticsError"
            ></div>
          </div>
        </div>

        <div class="tabs-container" [hidden]="showAnalytics">
            <div class="tabs-header">
              <button
                class="tab-button"
                [class.active]="activeTab === 'assetRequest'"
                (click)="setActiveTab('assetRequest')"
              >
                Asset Request
              </button>
              <button
                class="tab-button"
                [class.active]="activeTab === 'createdPolicies'"
                (click)="setActiveTab('createdPolicies')"
              >
                Created Policies
              </button>
            </div>

            <div class="tab-content-wrapper">
              <div class="tab-content" [hidden]="activeTab !== 'assetRequest'">
                <app-asset-request
                  [showPurposeColumn]="false"
                  [showRequestTypeColumn]="false"
                  [showAssetOwnerColumn]="true"
                  [showRequestDateColumn]="true"
                  [showCreatedAtColumn]="false"
                  [showActionColumn]="true"
                  [canApproveReject]="false"
                  [showFilters]="true"
                  [showOrganisationFilter]="true"
                  [enableRequestStatusTabs]="true"
                  [serverSideSorting]="true"
                  [applyServerSortOnlyAfterUserSort]="true"
                  (reloadData)="loadAssetRequests()"
                >
                  <div requestStatusToolbarActions>
                    <ng-container *ngTemplateOutlet="accessRequestsViewToggle"></ng-container>
                  </div>
                </app-asset-request>
              </div>

              <div class="tab-content" *ngIf="activeTab === 'createdPolicies'">
                <app-created-policies policyPortal="platform"></app-created-policies>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
